import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { SsrModule } from 'app/constants/ssrModules';
import { Spinner } from 'app/design-system/components/Spinner';
import { asyncQueue } from 'app/lib/asyncQueue';
import useComponentWillMount from 'app/lib/hooks/useComponentWillMount';
import { selectSignalrConnected } from 'app/lib/signalr';
import { fetchLive } from 'app/modules/Live/actions';
import { LIVE_TOPIC, subscribe, unsubscribe } from 'app/modules/Live/actions/liveHub';
import { entityRequested } from 'app/modules/Live/selectors/entities';
import { isSSR } from 'app/packages/components';

import { RootMenu } from '../../components/RootMenu';
import {
  entityLoading,
  matchIds,
  rootMenuItemsWithPathname,
} from '../../selectors/live';

export const LiveMenu: React.FC = () => {
  const dispatch = useDispatch();
  const signalrConnected = useSelector(selectSignalrConnected);
  const requested = useSelector(entityRequested);
  const { pathname } = useLocation();

  useComponentWillMount(() => {
    if (isSSR && !requested) {
      dispatch(fetchLive());
    }
  });

  useEffect(() => {
    return () => {
      asyncQueue.removeFromQueue(LIVE_TOPIC, () => dispatch(unsubscribe()));
    };
  }, []);

  useEffect(() => {
    if (signalrConnected) {
      asyncQueue.addToQueue(LIVE_TOPIC, () => dispatch(subscribe()));
    }
  }, [signalrConnected]);

  const hasMatchIds = useSelector(matchIds).size > 0;
  const loading = useSelector(entityLoading);
  const realLoading = !hasMatchIds && loading;
  const items = useSelector(rootMenuItemsWithPathname(pathname));

  return (
    <>
      {realLoading
        ? <Spinner size={40} />
        : (
          <RootMenu ssrDataId={SsrModule.LEFT_MENU_LIVE}
                    list={items} />
        )
      }
    </>
  );
};
